export default "__VITE_ASSET__Da23CLzd__"